import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Footer.css";
import useLocation from "../../utils/Location";
import { getWhatsappLink } from "../../utils/getWhatsappNumber";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);
  const [open, setOpen] = useState(false);
  const footerRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (footerRef.current && !footerRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="containerFooter">
      <div className="innerDivFooter">
        <h1 className="headingFooter">Ready to Go Digital With NFC?</h1>
        <h4 className="subheadingFooter">
          Switch to BusinessBay NFC cards and go to digital. Share instantly ,
          connect smarter, and leave paper behind. Your network deserves the
          future today.
        </h4>

        {/* Wrapper */}
        <div
          ref={footerRef}
          className={`buttonFooter ${open ? "openfooter" : ""}`}
        >
          {/* Expandable Part */}
          <AnimatePresence>
            {open && (
              <motion.div
                className="widget-greetings-wrapper"
                initial={{ opacity: 0, height: 0, y: 20 }}
                animate={{ opacity: 1, height: "auto", y: 0 }}
                exit={{ opacity: 0, height: 0, y: 20, border: "none" }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
              >
                <p className="widget-para">Let’s get started!</p>
                <p className="widget-para">
                  Please share a few basic details with us so we can start the
                  conversation.
                </p>
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ctawhatsapp"
                >
                  <motion.button
                    type="button"
                    className="startbutton"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0 }}
                  >
                    Start
                  </motion.button>
                </a>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Trigger Button (stays at the bottom always) */}
          <div className="bottom-wrapper" onClick={() => setOpen(!open)}>
            <span className="bottom-wrapper-span">
              Tell us about your needs
            </span>
            <a className="btn-box w-inline-block">
              <div className="btn-box-lines-icon w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M17 13L0.999999 13"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                  ></path>
                  <path
                    d="M17 5L0.999999 5"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                  ></path>
                </svg>
              </div>
            </a>
          </div>
        </div>
        {countryCode && countryCode == "in" ? (
          <a
            href="https://wa.me/917835065469"
            className="whatsappFloat"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
          >
            <FaWhatsapp size={32} />
          </a>
        ) : (
          <a
            href="https://wa.me/971562198924"
            className="whatsappFloat"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
          >
            <FaWhatsapp size={32} />
          </a>
        )}
      </div>
    </div>
  );
};

export default Footer;
